import { ternary, valueOrDefault } from '@/utils/common.js'

const defaultLocalStorage = window.localStorage
const defaultSessionStorage = window.sessionStorage

export const getLocalStorageData = key => {
  const data = valueOrDefault(defaultLocalStorage.getItem(key), '')
  try {
    return JSON.parse(data)
  } catch (e) {}
  return data
}

export const setLocalStorageData = (key, value) => {
  const newValue = ternary(
    typeof value === 'string',
    value,
    JSON.stringify(value)
  )
  defaultLocalStorage.setItem(key, newValue)
}

export const getSessionStorageData = key => {
  const data = valueOrDefault(defaultSessionStorage.getItem(key), '')
  if (data) {
    try {
      return JSON.parse(data)
    } catch (e) {
      console.error(e)
    }
  }
  return data
}

export const setSessionStorageData = (key, value) => {
  defaultSessionStorage.setItem(key, JSON.stringify(value))
}

export const removeSessionStorageData = key => {
  defaultSessionStorage.removeItem(key)
}
